<template>
  <div>
    <common-dialog
      ref="dialog"
      width="500px"
      show-save-button
      unit="班次"
      edit-title
      id-key="ScheduleId"
      :data="data"
      :line-form="true"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      @opened="onOpened"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <template>
          <el-form-item label="班次名称" prop="Schedule">
            <el-input v-model="data.Schedule" placeholder="请输入名称" />
          </el-form-item>
        </template>
        <template>
          <el-form-item label="开始时间" prop="StartTime">
            <el-time-select
              v-model="data.StartTime"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:55',

              }"
              placeholder="选择时间"
            ></el-time-select>
          </el-form-item>
        </template>
        <template>
          <el-form-item label="结束时间" prop="EndTime">
            <el-time-select
              v-model="data.EndTime"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '23:55',
              }"
              placeholder="选择时间"
            >
            </el-time-select>
          </el-form-item>
        </template>
        <template>
          <el-form-item label="序号" prop="Sn">
            <el-input
              type="number"
              v-int
              v-model="data.Sn"
              style="width: 100px"
            ></el-input>
            <!-- <el-input-number v-model.number="data.Sn" :min="0" step-strictly style="width: 100px" ></el-input-number> -->
            <span class="t-tips">*值越小排得越前</span>
          </el-form-item>
        </template>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";
export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    let validateEndTime = (rule, value, callback) => {
      if (!value) {
        callback("结束时间不能为空");
      }
      if (this.data.StartTime) {
        let StartTime = this.data.StartTime.split(":");
        let EndTime = value.split(":");
        console.log("StartTime", StartTime);
        console.log("EndTime", EndTime);

        // if (
        //   ~~StartTime[0] > ~~EndTime[0] ||
        //   (~~StartTime[0] >= ~~EndTime[0] && ~~StartTime[1] >= ~~EndTime[1])
        // ) {
        //   callback("结束时间必须大于开始时间！");
        // } else {
          callback();
       // }
      }
    };
    return {
      data: {
        ScheduleId: 0,
        Schedule: "",
        StartTime: "",
        EndTime: "",
        Sn: null,
      },
      api: require("@/api/ba/schedule").default,
      showList: [],
      rules: {
        Schedule: [{ required: true, message: "名称不能为空" }],
        StartTime: [{ required: true, message: "开始时间不能为空" }],
        EndTime: [
          {
            required: true,
            validator: validateEndTime,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    // 打开时获取显示显示列表
    onOpened() {},
    onCreateOpened() {
      this.api.getMaxSn().then((res) => {
        this.data.Sn = res;
      });
    },
    onEditOpened(data) {},
    onClosed() {
      this.showList = [];
    },
  },
};
</script>
